if (!customElements.get('lq-gift-finder')) {
  customElements.define(
    'lq-gift-finder',
    class giftFinder extends HTMLElement {
      constructor() {
        super();
        const data = this.dataset;
        this.initialUrl = data.initialUrl;
        this.sectionName = data.sectionName;
        this.filterConnections = data.filterConnections.split(',');
        this.currentFetchURL = this.initialUrl;
        this.maxSliderItems = parseInt(data.maxSliderItems, 10);
        this.viewAllButton = this.querySelector('.view-all-button');

        this.giftProducts = this.querySelector('lq-gift-products');
        this.customSelectors = this.querySelectorAll('lq-custom-selector');

        this.clearFiltersButton = this.querySelector('.clear-filter-button');
        this.productListContainer = this.giftProducts.querySelector('ul');
        this.slideshowComponent = this.giftProducts.querySelector('slider-component');
        this.slideClassList = this.productListContainer.querySelectorAll('li')[0].classList;

        this.clearFiltersButton.addEventListener('click', this.clearFilters.bind(this));
        this.screenBiggerThan = window.matchMedia("(min-width: 750px)").matches;

        this.customSelectors.forEach((customSelector) => {
          const detailsElement = customSelector.querySelector('details');
          detailsElement.addEventListener('toggle', (event) => {
            event.preventDefault();
            if (!detailsElement.open) {
              const url = this.buildUrl();
              if (url !== this.initialUrl) { // there are filters
                this.fetchFavoriteProducts(url, this.screenBiggerThan);
              }
            }
          });
        });

        this.resizeListener = () => {
          this.screenBiggerThan = window.matchMedia("(min-width: 750px)").matches;
        };
        window.addEventListener("resize", this.resizeListener);
      }

      connectedCallback() {
        this.clearFiltersButton.addEventListener('click', this.clearFiltersHandler);
        this.fetchFavoriteProducts(this.initialUrl, false);
      }

      disconnectedCallback() {
        // Remove event listeners when the element is removed from the DOM
        this.clearFiltersButton.removeEventListener('click', this.clearFiltersHandler);
      }

      fetchFavoriteProducts(url = this.initialUrl, renderSlider = true) {
        if (renderSlider) {
          if (this.currentFetchURL === url) {
            return;
          }
        }
        this.updateViewAllButton(url);
        this.giftProducts.classList.add('loading');

        let urlWithoutCSS = '';
        if (url.includes('?')) {
          urlWithoutCSS = url + '&view=empty'
        } else {
          urlWithoutCSS = url + '?view=empty'
        }

        fetch(urlWithoutCSS)
          .then((response) => response.text())
          .then((text) => {
            const collectionPage = document.createElement('div');
            collectionPage.innerHTML = text;
            if (renderSlider) {
              const favoriteProducts = collectionPage.querySelectorAll('#product-grid li');
              this.buildSlider(favoriteProducts);
              this.viewAllButton.querySelector('.count').innerText = '(' + favoriteProducts.length + ')';
            }
            const remotePageFilters = collectionPage.querySelectorAll('#FacetFiltersForm details');
            this.findCustomSelector(remotePageFilters);
            this.currentFetchURL = url;
          })
          .then(() => {
            this.giftProducts.classList.remove('loading');
            setTimeout(() => {
              this.viewAllButton.querySelector('.loading__spinner').classList.add('hidden');
              this.viewAllButton.classList.remove('loading');
            } , 150);
          })
          .catch(error => console.error('Error fetching products:', error));
      };
      updateViewAllButton(url) {
        this.viewAllButton.querySelector('.loading__spinner').classList.remove('hidden');
        this.viewAllButton.classList.add('loading')
        this.viewAllButton.href = url;

      }
      buildUrl() {
        const filters = [];
        this.customSelectors.forEach((customSelector) => {
          const filterBy = customSelector.dataset.filterBy.split(',');
          const filterPath = customSelector.dataset.filterPath;
          filterBy.forEach(filter => {
            if (filter) {
              filters.push(`${filterPath}${filter}`);
            }
          });
        });
        return filters.length > 0 ? `${this.initialUrl}?${filters.join('&')}` : this.initialUrl;
      }

      buildSlider(products) {
        this.productListContainer.innerHTML = '';
        products = Array.from(products).slice(0, this.maxSliderItems);
        products.forEach((product, index) => {
          product.setAttribute('id', `Slide-${this.sectionName}-${index + 1}`);
          product.setAttribute('tabindex', '-1');

          this.slideClassList.forEach((className) => {
            product.classList.add(className);
          });
        });

        this.productListContainer.append(...products);

        this.slideshowComponent.resetPages();
        this.slideshowComponent.setSlidePosition(0);

      }

      findCustomSelector(filters) {
        let matchingFilters = [];
        filters.forEach((filter) => {
          const contentConnector = filter.dataset.contentConnector;
          if (this.filterConnections.includes(contentConnector)) {
            matchingFilters.push(filter);
          }
        });
        matchingFilters.forEach((filter) => {
          this.updateMatchingFilers(filter);
        });
      }

      updateMatchingFilers(filter) {
        let filterName = filter.dataset.contentConnector;
        let matchingCustomSelector = this.querySelector(`lq-custom-selector[data-filter-group-name="${filterName}"]`);
        let receivedItems = filter.querySelectorAll('.list-menu__item label');

        // Reset all the disabled items
        matchingCustomSelector.querySelectorAll('.tag-list a').forEach((item) => {
          item.disabled = false;
          item.classList.remove('disabled');
        });

        const items = matchingCustomSelector.querySelectorAll('.tag-list a');
        items.forEach((item) => {
          let matchingItem = Array.from(receivedItems).find(
            (receivedItem) => receivedItem.dataset.connection === item.dataset.filter
          );
          if (!matchingItem || matchingItem.classList.contains('disabled')) {
            item.disabled = true;
            item.classList.add('disabled');
          }
        });
      }

      clearFilters() {
        this.customSelectors.forEach((customSelector) => {
          customSelector.setAttribute('data-filter-by', '');
          customSelector.selectDisplay.innerText = '';
          customSelector.querySelectorAll('.tag-list a').forEach((item) => {
            item.classList.remove('active');
            item.classList.remove('disabled');
          });
        });
        this.fetchFavoriteProducts(this.initialUrl);
      }

      clearFiltersHandler = (e) => {
        e.preventDefault();
        this.clearFilters();
      }
    }
  );
}

if (!customElements.get('lq-custom-selector')) {
  customElements.define(
    'lq-custom-selector',
    class customSelector extends DetailsDisclosure {
      constructor() {
        super();
        const data = this.dataset;

        this.filterPath = data.filterPath;
        this.filterBy = data.filterBy;
        this.filterGroupName = data.filterGroupName;
        this.multiselection = data.multiselection;

        this.selectDisplay = this.querySelector('.select-display');
        this.filterItems = this.querySelectorAll('.tag-list a');
        this.closePanel = this.querySelector('.close-panel');

        this.filterItems.forEach((item) => {
          item.addEventListener('click', (e) => {
            this.onFilterClick(e);
          });
        });
        if (this.closePanel) {
          this.closePanel.addEventListener('click', (e) => {
            e.preventDefault();
            setTimeout(() => {
              this.close();
            }, 100);
          });
        }
      }

      onFilterClick(e) {
        e.preventDefault();

        let targetElement = e.target.closest('a');
        if (targetElement.classList.contains('disabled')) {
          return; // Exit early if the clicked item is disabled.
        }

        const isActive = targetElement.classList.contains('active');

        if (this.multiselection === 'false') {
          // For single selection, deactivate all other items except the clicked one.
          this.filterItems.forEach(item => item.classList.remove('active'));
          if (!isActive) {
            targetElement.classList.add('active'); // Only add 'active' if it wasn't active before.
          }
        } else {
          // For multi-selection, simply toggle the 'active' state of the clicked item.
          targetElement.classList.toggle('active');
        }
        // Update the display and attribute based on the current selection.
        this.updateSelectionDisplayAndAttribute();
      }
      updateSelectionDisplayAndAttribute() {
        const selectedItems = Array.from(this.filterItems)
          .filter(item => item.classList.contains('active'))
          .map(item => item.innerText);

        this.selectDisplay.innerText = selectedItems.join(', ');
        this.setAttribute('data-filter-by', selectedItems.join(','));

        if (this.multiselection === 'false') {
          setTimeout(() => {
            this.close();
          }, 150);
        }
      }
    }
  );
}
